export default "__VITE_ASSET__DEy6udAT__"